
import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface TutorialCreatorHeaderProps {
  onBack: () => void;
  existingTutorial?: any;
}

const TutorialCreatorHeader: React.FC<TutorialCreatorHeaderProps> = ({
  onBack,
  existingTutorial
}) => {
  return (
    <div className="flex items-center gap-4 mb-6">
      <Button variant="ghost" size="sm" onClick={onBack}>
        <ArrowLeft size={16} className="mr-2" />
        Back to Tutorials
      </Button>
      <h1 className="text-2xl font-bold text-foreground">
        {existingTutorial ? "Edit Tutorial" : "Create New Tutorial"}
      </h1>
    </div>
  );
};

export default TutorialCreatorHeader;
